import { version } from "./../../node_modules/printj/types/index.d";
import { useQuery, UseQueryResult } from "@tanstack/react-query";
import config from "../config.json";
import { createAxiosInstance } from "./ServicesHelpers";

const axiosInstance = createAxiosInstance(config.ADMIN_API_BASE_URL);

export enum RateSheetFileName {
  DATE,
  ACCOUNT_USER_NAME,
  SMPP_USERNAME,
  ACCOUNT_PROFILE_NAME,
}
export enum RateSheetFormat {
  CSV,
  XLSX,
  XLS,
}
export interface RateTemplateType {
  id: string;
  name: string;
  country: string;
  operator: string;
  cc: string;
  mcc: string;
  mnc: string;
  mccmnc: string;
  oldPrice: string;
  newPrice: string;
  rateSheetFileName: string;
  currency: string;
  change: string;
  effectiveDate: string;
  version: number;
  rateSheetFormat: "CSV" | "XLSX" | "XLS";
  includeLogo: boolean;
}

export async function fetchRateTemplates(): Promise<RateTemplateType> {
  try {
    const response = await axiosInstance.get("/templates/rates");
    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.message ||
        "An error occurred while getting the rate template."
    );
  }
}

export async function fetchRateTemplate(): Promise<RateTemplateType> {
  try {
    const response = await axiosInstance.get(`/templates/rates/all`);
    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.message ||
        `An error occurred while getting rate template.`
    );
  }
}

export const editRateTemplateApi = async (data: Partial<RateTemplateType>) => {
  try {
    const response = await axiosInstance.put(`/templates/rates`, data);
    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.message ||
        "An error occurred while updating the rate template."
    );
  }
};

export const useRateTemplatesQuery = (): UseQueryResult<
  RateTemplateType,
  Error
> => {
  return useQuery({
    queryKey: ["rateTemplates"],
    queryFn: fetchRateTemplates,
  });
};
